/*
 * Recruit
 */

(function ($) {
    /* galleries scroll */
    var recruit_galleries = $('.recruit_galleries');
    if (recruit_galleries.length > 0) {
        recruit_galleries.each(function () {
            var _this_scroll = $(this).find('.recruit_galleries__scroll');
            var _this_scroll_length = _this_scroll.find('._item').length;
            var _this_scroll_content = _this_scroll.html();
            var speed = $(this).data('speed') || _this_scroll_length * 5000;

            _this_scroll.remove();
            $(this).append(
                '<div class="recruit_galleries__scroll" style="animation-duration:' + speed + 'ms;">' + _this_scroll_content + '</div>' +
                '<div class="recruit_galleries__scroll" style="animation-duration:' + speed + 'ms;">' + _this_scroll_content + '</div>'
            );
        });
    }

    var recruit_interview_slide = new Swiper(".recruit_interview_slider .swiper", {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        centeredSlides: false,
        initialSlide: 1,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: false,
        },
        breakpoints: {
            768: {
                slidesPerView: "auto",
                spaceBetween: 0,
            }
        }
    });

    recruit_interview_slide.on('slideChangeTransitionStart', function () {
        jQuery('.recruit_interview_slider .swiper-wrapper').css({ transition: 'transform 1000ms ease 0s' })
    });

})(jQuery);